import React, { useCallback, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import SearchIcon from '@material-ui/icons/Search';
import { IconButton } from '@material-ui/core';
import { toast } from 'react-toastify';
import { MdPrint } from 'react-icons/md';
import Grid24 from '../../../components/UI/Grid24';
import {
  findControleDeEntrada, findControleDeEntradaAgrupado, findUsuariosPermitidos, imprimirControleEntrada,
} from '../../../services/core/controleBordero/controleBordero.service';
import {
  getCurrentIdUsuario, getMoneyMask, openPageFileBase64, toBrazilianDate,
} from '../../../helpers';
import SelectorModel from '../../../models/SelectorModel';
import DateField from '../../../components/UI/Field/Date/DateField';
import { ButtonUI, SelectorField } from '../../../components';
import TabelaEntradas from './TabelaEntradas';
import useStyle, {
  CardTop, ContainerPrincipal, ResumoContainer, WrapperFormWithTitle,
} from './ControleEntradaStyles';
import { ButtonImprimir } from '../../RecebimentoDevedores/RecebimentoDevedoresStyles';

function ControleEntradaComponent() {
  const styles = useStyle();


  function subtractMonths(date, monthsToSubtract) {
    date.setMonth(date.getMonth() - monthsToSubtract);
    return date;
  }
  const [usuarios, setUsuarios] = useState([]);
  const [usuarioSelecionado, setUsuariosSelecionado] = useState(0);
  const [dataInicial, setDataInicial] = useState(toBrazilianDate((subtractMonths(new Date(), 1)).setDate(26)));
  const [dataFinal, setDataFinal] = useState(toBrazilianDate((new Date()).setDate(25)));
  const [controleDeEntrada, setControleDeEntrada] = useState([]);
  const [controleDeEntradaAgrupado, setControleDeEntradaAgrupado] = useState([]);
  const [isTotalizarPorCliente, setIsTotalizarPorCliente] = useState(false);

  useEffect(() => {
    if (usuarios.length === 0) {
      findUsuariosPermitidos(getCurrentIdUsuario()).then((response) => {
        const resposta = response.data.map(usuario => (new SelectorModel(usuario.idUsuario, usuario.nomeUsuario)));
        setUsuarios(resposta);
      });
    }
  },
  [usuarios]);

  const onSubmitHandler = useCallback(() => {
    findControleDeEntrada(dataInicial, dataFinal, usuarioSelecionado).then((response) => {
      setControleDeEntrada(response.data);
      if (response.data.length === 0) {
        toast.warn('Nenhum resultado foi encontrado relacionado à sua pesquisa');
      }
    });
    findControleDeEntradaAgrupado(dataInicial, dataFinal, usuarioSelecionado).then((response) => {
      setControleDeEntradaAgrupado(response.data);
    });
  }, [dataInicial, dataFinal, usuarioSelecionado]);

  const onClickImprimir = useCallback(() => {
    imprimirControleEntrada(dataInicial, dataFinal, usuarioSelecionado, isTotalizarPorCliente).then((response) => {
      if (response.data.length > 0) {
        openPageFileBase64(response.data, response.headers['content-type']);
      }
    }).catch(() => {
      toast.error('Erro ao gerar o PDF. Tente novamente mais tarde.');
    });
  }, [dataInicial, dataFinal, usuarioSelecionado, isTotalizarPorCliente]);

  return (
    <ContainerPrincipal>
      <Grid24 item xs={24} sm={20} style={{ margin: '5px' }}>
        <div style={{ margin: '5px' }}>
          <DateField
            isForm
            disabled={usuarios.length === 0}
            label="Data Inicial"
            name="Data Inicial"
            value={dataInicial}
            onChange={e => setDataInicial(e.target.value)}
          />
        </div>
        <div style={{ margin: '5px' }}>
          <DateField
            isForm
            disabled={usuarios.length === 0}
            label="Data Final"
            name="Data Final"
            value={dataFinal}
            onChange={e => setDataFinal(e.target.value)}
          />
        </div>
        <div style={{ margin: '5px', width: '300px' }}>
          <SelectorField
            isForm
            disabled={usuarios.length === 0}
            label="Contato"
            items={usuarios}
            name={usuarioSelecionado.name}
            value={usuarioSelecionado.value}
            onChange={(event) => { setUsuariosSelecionado(event.target.value); }}
          />
        </div>
        <div style={{ marginTop: 'auto' }}>
          <IconButton
            onClick={onSubmitHandler}
            disabled={usuarioSelecionado === 0 || dataInicial === '' || dataFinal === ''}
            type="submit"
            className={styles.button}
          >
            <SearchIcon />
          </IconButton>
        </div>
        <div style={{ marginTop: 'auto', marginLeft: '5px' }}>
          <ButtonUI
            color="success"
            style={{ width: '270px' }}
            disabled={controleDeEntrada.length === 0 && controleDeEntradaAgrupado.length === 0}
            onClick={() => setIsTotalizarPorCliente(!isTotalizarPorCliente)}
          >
            {isTotalizarPorCliente ? ('Totalizar Informações por Data') : ('Totalizar Informações por Clientes')}
          </ButtonUI>
        </div>
        <div style={{ marginTop: 'auto', marginLeft: '5px' }}>
          <ButtonImprimir
            disabled={controleDeEntrada.length === 0 && controleDeEntradaAgrupado.length === 0}
            onClick={onClickImprimir}
          >
            <MdPrint size={16} />
            <span>Imprimir</span>

          </ButtonImprimir>
        </div>
      </Grid24>
      <Grid24 item xs={24} sm={21} style={{ margin: '10px' }}>
        <ResumoContainer>
          <p className="title">Resumo</p>
          <div>
            <CardTop color="#a3a1a3">
              <p>Número de Processos</p>
              <p>{controleDeEntradaAgrupado.reduce((acc, item) => acc + item.quantidade, 0)}</p>
            </CardTop>
            <CardTop color="#a3a1a3">
              <p>Borderôs de Clientes Novos</p>
              <p>
                {controleDeEntradaAgrupado.filter(item => item.isClienteNovo === 'Sim')
                  .reduce(acc => acc + 1, 0)}
              </p>
            </CardTop>
            <CardTop color="#a3a1a3">
              <p>Total de Borderôs</p>
              <p>
                {getMoneyMask(controleDeEntradaAgrupado.filter(item => item.isClienteNovo !== 'Sim')
                  .reduce((acc, item) => acc + item.total, 0))}
              </p>
            </CardTop>
            <CardTop color="#a3a1a3">
              <p>Total Clientes Novos</p>
              <p>
                {getMoneyMask(controleDeEntradaAgrupado.filter(item => item.isClienteNovo === 'Sim')
                  .reduce((acc, item) => acc + item.total, 0))}
              </p>
            </CardTop>
          </div>
        </ResumoContainer>
      </Grid24>
      <Grid24 item xs={24} sm={21}>
        <>
          <div style={{ margin: '5px' }}>
            <WrapperFormWithTitle title="Entradas">
              <TabelaEntradas
                content={isTotalizarPorCliente ? controleDeEntradaAgrupado : controleDeEntrada}
              />
            </WrapperFormWithTitle>
          </div>
        </>
      </Grid24>
    </ContainerPrincipal>
  );
}

export const ControleEntrada = withRouter(ControleEntradaComponent);
